// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"aec48779","1799":"a747f485","4035":"c7cde834","5541":"bae88a5c","5959":"96df37ed"}[chunkId] + ".chunk.css";
};